import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setSilosGrid = (state, { silosGrid }) => {
  if (!silosGrid) return state;
  return state.merge({ silosGrid });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_SILOS_GRID,
    actionFunction: setSilosGrid,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
